import React from "react";
import { useGlobalContext } from "../context/stateContext";
import { Navigate, Outlet } from "react-router-dom";
import Loading from "../components/Loading/Loading";

const RoleBasedRoutes = ({
  allowedRoles,
  component: Component,
  fallback = "/not-found",
  ...rest
}) => {
  const { currentUser } = useGlobalContext();
  const userRole = currentUser?.role;

  if (!currentUser) {
    return <Loading />;
  }

  if (allowedRoles.includes(userRole)) {
    return Component ? <Component {...rest} /> : <Outlet {...rest} />;
  }

  return <Navigate to={fallback} replace />;
};

export default RoleBasedRoutes;
